import React, { useState } from 'react';
import './email.css';

const translations: Record<string, { description: string; send: string; sent: string }> = {
  pt: {
    description: 'Adicione seu email para saber de novas exposições',
    send: 'Enviar',
    sent: 'Enviado!'
  },
  en: {
    description: 'Add your email to be notified of new exhibitions',
    send: 'Send',
    sent: 'Sent!'
  }
}

const Email: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [sent, setSent] = useState<boolean>(false);

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    fetch('/.netlify/functions/emails', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email }),
    });
    setSent(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  }

  return (
    <form className='email' onSubmit={submit}>
      <p>{translations[window.location.pathname.substring(1)]?.description || translations['pt'].description}</p>
      <div>
        <input placeholder='email' value={email} onChange={handleChange}/>
        <button type='submit'>{translations[window.location.pathname.substring(1)]?.send || translations['pt'].send}</button>
      </div>
      {sent && <span>{translations[window.location.pathname.substring(1)]?.sent || translations['pt'].sent}</span>}
    </form>
  );
}

export default Email;
